// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f53b0494","455":"dbeb162c","977":"9356a8e9"}[chunkId] + ".chunk.js";
};